import Button from '@stone/ui/button/Button';
import api from '@utils/api';
import React from 'react';
import { useTranslation } from 'react-i18next';
const RegisteredInStoreSendEmail = (props) => {
    const { t } = useTranslation();
    const sendEmail = () => {
        api.forgotPasswordSendMail(props.loginEmail);
        props.setLoginStep('registeredInStore');
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col" },
                React.createElement("p", { className: "mb-12", dangerouslySetInnerHTML: {
                        __html: t('login.registeredinstore.welcomeback', { 0: props.loginEmail }),
                    } }),
                React.createElement(Button, { cls: ['button--tertiary'], type: "button", onClick: () => props.setLoginStep('email') }, t('login.editemail')))),
        React.createElement("div", { className: "row mt-60 send-email-registered" },
            React.createElement(Button, { type: "button", cls: ['button--primary'], onClick: () => sendEmail(), className: "full" }, t('login.registeredinstore.sendemail')))));
};
export default RegisteredInStoreSendEmail;
